import { TrackingEventNames as BaseTrackingEventNames } from '../../common/tracking/tracking-event-names.model';

export const TrackingEventNames = {
  ...BaseTrackingEventNames,
  ASSET_TEMPLATE_SHELL: 'asset_template_shell',
  ASSET_TEMPLATE_OVERVIEW: 'asset_template_info_page',
  USER_SHELL: 'admin_users_shell',
  USER_OVERVIEW: 'user_info_page',
  PO_EVENT_RULE_SHELL: 'po_event_rule_shell',
  PO_EVENT_RULE_OVERVIEW: 'po_event_rule_info_page',
  ESCALATION_PROTOCOL_SHELL: 'escalation_protocol_shell',
  ESCALATION_PROTOCOL_OVERVIEW: 'escalation_protocol_page',
  TOPICS_SHELL: 'topics_shell',
  TOPICS_OVERVIEW: 'topic_info_page',
  PRODUCT_CATALOGS_SHELL: 'product_catalogs_shell',
  EMAIL_TEMPLATES_SHELL: 'email_templates_shell',
  API_KEYS_SHELL: 'api_keys_shell',
  SITE_OVERVIEW: 'site_info_page',
  ASSET_OVERVIEW: 'asset_info_page',
  SCHEDULERS_SHELL: 'schedulers_shell',
  SCHEDULER_OVERVIEW: 'scheduler_info_page'
};
